//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from "./../store";
import tweetsAPI from "./../apis/tweets";
import { Toast } from "./../utils/helpers";
import { fromNowFilter } from "./../utils/mixins";

export default {
  name: "ReplyModal",
  mixins: [fromNowFilter],
  props: {
    initialTweetDetail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentUser: {
        id: "",
        avatar: "",
        name: "",
      },
      comment: "",
    };
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    fetchUserInfo() {
      const { account, avatar, id } = store.state.currentUser;
      this.currentUser = { account, avatar, id };
    },
    // async fetchTweetsDetail(id) {
    //   try {
    //     const { data } = await tweetsAPI.getTweetDetail({ id });
    //     console.log(data);
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    async handleSubmit() {
      try {
        const { data } = await tweetsAPI.replyTweets({
          tweetId: this.$route.params.id,
          comment: this.comment,
        });
        console.log(data);
        if (data.status === "error") {
          throw new Error(data.message);
        }
        console.log(data);

        Toast.fire({
          icon: "success",
          title: data.message,
        });

        this.$emit("modal-reply-tweet");
        this.comment = ""; // 將表單內的資料清空
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
  },
};
